'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
angular.module('user.model', ['form.services']).factory('User', [function () {
  /**
   * A SCIM like user as returned by the account-management service and expected by entities such as tiers
   * @param {object} data [description]
   * @class User
   * @classdesc SCIM like user
   */
  function User(data) {
    data = data || {};

    // we pick only data that we want, omitting extra informations added by account-management
    this.id = data.id;
    this.userName = data.userName;
    this.displayName = data.displayName || _.trim(_.get(data, 'name.givenName', '') + ' ' + _.get(data, 'name.familyName', ''));
    this.emails = data.emails || [];
    this.phoneNumbers = data.phoneNumbers || [];
    this.groups = data.groups;
    this.name = {};
    this.dateTimeLastLogin = data.dateTimeLastLogin;
    if (_.get(data, 'name.honorificPrefix')) {
      this.name.honorificPrefix = data.name.honorificPrefix;
    }
    this.name.givenName = _.get(data, 'name.givenName');
    this.name.familyName = _.get(data, 'name.familyName');

    // With france connect, it's possible to get birthdate and birthplace (with code INSEE)
    this.birthplace = data.birthplace;
    this.birthdate = data.birthdate;

    // For OIdC users
    this.birthplaceName = data.birthplaceName;
    this.birthcountryName = data.birthcountryName;
    this.costCenter = data.costCenter; // direction
    this.division = data.division; // service
    this.divisionLabel = data.divisionLabel;
    this.department = data.department; // pôle
    this.departmentLabel = data.departmentLabel;
    this.organizationUnit = data.organizationUnit; // organization
    this.organizationUnitLabel = data.organizationUnitLabel;
    this.businessUnit = data.businessUnit; // direction
    this.businessUnitLabel = data.businessUnitLabel;
    this.title = data.title; // fonction
    this.franceConnect = data.franceConnect;
    this.self = data.self;
    this.dateAcceptationCGU = data.dateAcceptationCGU;
    this.agreements = data.agreements;
    this.groupsGestion = data.groupsGestion;
    this.providerId = data.providerId || _.get(data, 'meta.providerId'); // Depending on where the data comes from
    this.sub = data.sub;

    // account security data
    this.locked = data.locked; // is the account locked
    this.failTime = data.failTime; // last failled authentication attempts
    this.attempts = data.attempts; // number of successive failled attempts
  }

  /**
   * This function returns the user in a form compatible with Tiers services and others
   * If serialization problems are fixed in these services the need for this function should disappear.
   * @returns {object} User
   */
  User.prototype.getCleanEntity = function () {
    var user = _.cloneDeep(this);

    // Emails
    if (user.emails && user.emails.length > 0) {
      user.emails = _.map(user.emails, function (email, i) {
        if (typeof email === 'string') {
          return {
            value: email,
            primary: i === 0,
            type: 'work'
          };
        } else if (_typeof(email) === 'object') {
          return email;
        } else {
          return '';
        }
      });
    } else {
      delete user.emails;
    }

    // Phone Numbers
    if (user.phoneNumbers && user.phoneNumbers.length > 0) {
      user.phoneNumbers = _.map(user.phoneNumbers, function (phoneNumber, i) {
        if (typeof phoneNumber === 'string') {
          return {
            value: phoneNumber,
            primary: i === 0,
            type: 'work',
            display: phoneNumber
          };
        } else if (_typeof(phoneNumber) === 'object') {
          return phoneNumber;
        } else {
          return '';
        }
      });
    } else {
      delete user.phoneNumbers;
    }

    // Groups
    if (user.groups && user.groups.length > 0) {
      user.groups = _.map(user.groups, function (group) {
        if (typeof group === 'string') {
          return {
            display: group,
            value: group
          };
        } else if (_typeof(group) === 'object') {
          return group;
        } else {
          return '';
        }
      });
    } else {
      delete user.groups;
    }

    // Registering only the honorific prefix label
    user.name = user.name || {};
    user.name.honorificPrefix = _.get(user, 'name.honorificPrefix.libelle') || _.get(user, 'name.honorificPrefix');
    return user;
  };
  return User;
}]);
(function () {
  'use strict';

  // interact with the account-management service developped at mgdis
  // see http://gitserv/gitweb/?p=mgdis/backend/account-management.git;a=summary
  angular.module('user.services.account-management-service', ['user.model', 'configuration']).factory('accountManagementService', ['$http', 'configuration', 'User', function ($http, configuration, User) {
    // See http://stackoverflow.com/questions/20305615/configure-angularjs-module-to-send-patch-request
    // to add HTTP PATCH method
    $http.defaults.headers.patch = {
      'Content-Type': 'application/json;charset=utf-8'
    };
    var _tenantId;

    /**
     * Constructs the URL for user account management
     * @returns {string} The constructed URL for user account management
     */
    function _getUrl() {
      // Check if _tenantId is truthy (i.e., a valid ID is present)
      return _tenantId ? configuration.user.accountManagement + '/' + _tenantId + '/users/' // Tenant-specific URL
      : configuration.user.accountManagement + '/users/'; // Generic URL without tenant scoping
    }

    /**
     * Get the administration url from configuration
     * @returns {string} administration url
     */
    function _getUrlAdmin() {
      return configuration.user.accountManagementAdmin;
    }
    return {
      tenantId: function tenantId(_tenantId2) {
        _tenantId = _tenantId2;
      },
      /**
       * Get the user's account
       * @param {string} userId The user id from which we want to get the account
       * @returns {object} The user requested
       */
      getAccount: function getAccount(userId) {
        return $http.get(_getUrl() + userId).then(function (response) {
          return new User(response.data);
        });
      },
      /**
       * Modify the user's account
       * @param {object} user The user which has to be modified
       * @returns {object} The user patch response
       */
      modifyAccount: function modifyAccount(user) {
        // If we send all the user object in this request, we get an HTTP code 406 with the following message :
        // Use special validation routes to modify active, emails and password attributes
        // So, pass only the needed values
        user = user.getCleanEntity();
        var newUser = {};
        newUser.name = {};
        newUser.name.honorificPrefix = user.name.honorificPrefix;
        newUser.name.givenName = user.name.givenName;
        newUser.name.familyName = user.name.familyName;
        newUser.displayName = user.name.givenName + ' ' + user.name.familyName;
        return $http({
          url: _getUrl() + user.userName,
          data: newUser,
          method: 'PATCH'
        });
      },
      /**
       * @param {string} userName id de l'utilisateur à modifier
       * @param {Array} patches tableau de patch à effectuer
       * @returns {object} The patch response
       */
      patchAccount: function patchAccount(userName, patches) {
        return $http({
          method: 'PATCH',
          url: _getUrl() + userName,
          headers: {
            'Content-Type': 'application/json-patch+json'
          },
          data: patches
        });
      },
      /**
       * Account creation is done in 2 shots, first request the creation with a scim-like user object
       * that contains email addresses. An email will be sent to validate the creation of the user
       * The actionURL parameter is used to tell the service where the validation link should point to
       * @param {object} user The user which has to be created
       * @param {string} url The url which will be in the confirmation email
       * @returns {object} The creation response
       */
      createAccount: function createAccount(user, url) {
        user = user.getCleanEntity();
        return $http.put(_getUrl() + user.userName, user, {
          params: {
            actionURL: url
          }
        });
      },
      /**
       * The application should triger this function when the account creation
       * confirmation link is clicked
       * @param {string} userId The user id which has to validate its account
       * @param {string} token The token is generated server side and is used to identify the account creation
       * @returns {object} The validation response
       */
      validateAccount: function validateAccount(userId, token) {
        return $http.put(_getUrl() + userId + '/active', null, {
          params: {
            token: token
          }
        });
      },
      /**
       * Forgotten password method used to change a password when not connected
       * in two shots, same as user creation
       * @param {string} userId The user id which wants to reset its account
       * @param {string} url The url which will be in the confirmation email
       * @returns {object} The reset password response
       */
      resetPassword: function resetPassword(userId, url) {
        return $http.put(_getUrl() + userId + '/password', null, {
          params: {
            actionURL: url
          }
        });
      },
      /**
       * Second part of the forgotten password method
       * @param {string} userId The user id which wants to validate its password
       * @param {string} token The token is generated server side and is used to identify the forgotten password request
       * @param {string} password The new password
       * @returns {object} The validation response
       */
      validatePassword: function validatePassword(userId, token, password) {
        return $http.put(_getUrl() + userId + '/password', password, {
          params: {
            token: token
          },
          headers: {
            'Content-type': 'text/plain'
          }
        });
      },
      /**
       * Modify password while connected
       * @param {string} userId The user id which wants to modify its password
       * @param {string} oldPassword The previously defined password
       * @param {string} newPassword The new password to be associated to the user
       * @returns {object} The modification password response
       */
      modifyPassword: function modifyPassword(userId, oldPassword, newPassword) {
        return $http({
          url: _getUrl() + userId + '/password',
          data: {
            newPassword: newPassword,
            oldPassword: oldPassword
          },
          method: 'PATCH'
        });
      },
      /**
       * Recover the user's email
       * @param {string} email The email whith which the user created its account
       * @returns {object} The recover email response
       */
      recoverEmail: function recoverEmail(email) {
        return $http.get(_getUrl() + 'email?email=' + email);
      },
      /**
       * Modify the email of the user
       * @param {string} userId The user id which wants to modify its email
       * @param {string} mail The new email
       * @param {string} password The user password
       * @param {string} actionURL : optionnal param to specify the page URL for email modification confirmation
       * @returns {object} The modification email response
       */
      modifyEmail: function modifyEmail(userId, mail, password, actionURL) {
        var emails = [mail];
        return $http.put(_getUrl() + userId + '/emails/', {
          email: emails,
          password: password
        }, {
          params: {
            actionURL: actionURL
          }
        });
      },
      /**
       * Modify the email of the user
       * @param {string} userId The user id which wants to validate its email
       * @param {string} email The user new email to be validated
       * @param {string} token The token is generated server side and is used to identify the modify email request
       * @returns {object} The validation response
       */
      validateEmail: function validateEmail(userId, email, token) {
        return $http.post(_getUrl() + userId + '/emails/' + email, null, {
          params: {
            token: token
          }
        });
      },
      /**
       * Tells whether there is an email modification pending for this user or not
       * @param {string} userId The user id which email state is being checked
       * @returns {object} The modification email response
       */
      emailModificationPending: function emailModificationPending(userId) {
        return $http.get(_getUrl() + userId + '/emails/state');
      },
      /**
       * Check if a password will be valid before allowing the user to submit
       * @param {string} password User password
       * @returns {object} The check passwor response
       */
      checkPassword: function checkPassword(password) {
        return $http.post(configuration.user.accountManagement + '/_check_password', '"' + password + '"').then(function (response) {
          return response.data;
        });
      },
      /**
       * Get publicSettings
       * @returns {object} The public settings response
       */
      getPublicSettings: function getPublicSettings() {
        return $http.get(_getUrlAdmin() + '/publicSettings');
      },
      /**
       * Return the Unpairing URL with a redirectTo parameter
       * @param {string} redirectTo redirectTo parameter
       * @param {string} jwtKey JWT key
       * @returns {object} The unpairing request response
       */
      getUnpairingUrl: function getUnpairingUrl(redirectTo, jwtKey) {
        return configuration.user.accountManagement + '/ux/#/account-unpairing' + '?redirectTo=' + redirectTo + '&jwtKey=' + jwtKey;
      },
      /**
       * Logout a user.
       * @param {string} tenantId tenant identifier
       * @param {string} token token
       * @param {string} redirectUrl redirection URL
       * @param {string} jwtKey jwt key
       * @param {string} redirectTo redirect to
       * @returns {object} The logout response
       */
      logout: function logout(tenantId, token, redirectUrl, jwtKey, redirectTo) {
        var url = "/account-management/api/public/tenants/".concat(tenantId, "/logout");
        return $http.post(url, {
          token: token
        }, {
          headers: {
            Authorization: "Bearer ".concat(token)
          },
          params: {
            redirectUrl: redirectUrl,
            jwtKey: jwtKey,
            redirectTo: redirectTo
          }
        });
      }
    };
  }]);
})();
'use strict';
// see http://blog.auth0.com/2014/01/07/angularjs-authentication-with-cookies-vs-token/
// Will be called on all $HTTP requests, deal with 401 returns and set the Authorization header
// Must be configured in the $http interceptors by the application
angular.module('user.services.authentication-interceptor-service', ['user.services.user-session-service', 'configuration']).factory('authInterceptor', ['userSessionService', 'configuration', function (userSessionService, configuration) {
  var includeCredentialsPrefixes = configuration.user.includeCredentialsPrefixes && configuration.user.includeCredentialsPrefixes.length > 0 ? configuration.user.includeCredentialsPrefixes : ['/'];
  var excludeCredentialsPrefixes = configuration.user.excludeCredentialsPrefixes || [];
  var urlMatchPrefixes = function urlMatchPrefixes(url) {
    if (!url) {
      return false;
    }
    var urlMatchPrefix = function urlMatchPrefix(prefix) {
      return url.indexOf(prefix) === 0;
    };
    if (!_.find(includeCredentialsPrefixes, urlMatchPrefix)) {
      return false;
    }
    if (_.find(excludeCredentialsPrefixes, urlMatchPrefix)) {
      return false;
    }
    return true;
  };
  return {
    request: function request(config) {
      config.headers = config.headers || {};
      if (urlMatchPrefixes(config.url) && userSessionService.getSessionId()) {
        config.headers.Authorization = 'Bearer ' + userSessionService.getSessionId();
      }
      return config;
    }
  };
}]);
'use strict';
// This service interacts with a CAS Rest exposition server and with the account-management service
// see https://wiki.jasig.org/display/casum/restful+api
// see http://gitserv/gitweb/?p=mgdis/backend/account-management.git;a=summary

angular.module('user.services.authentication-service', ['configuration', 'jwt.session', 'user.services.user-session-service']).factory('authenticationService', ['userSessionService', 'jwtSessionService', function (userSessionService, jwtSessionService) {
  return {
    /**
     * Connect a user to the portal
     * @param {string} username The username
     * @param {string} password The password
     * @returns {object} User connected
     */
    login: function login(username, password) {
      return jwtSessionService.login(username, password).then(function () {
        return userSessionService.getUser();
      });
    },
    /**
     * Disconnect a user from the portal
     */
    logout: function logout() {
      jwtSessionService.logout();
    },
    /**
     * Indicates if the current user is authenticated on the portal
     * @returns {boolean} True if user is authenticated
     */
    isAuthenticated: function isAuthenticated() {
      return !!userSessionService.getUserId();
    },
    /**
     * Indicates if the current user is authorized for parameters roles
     * @param {object} authorizedRoles Roles for which the authorization has to be checked
     * @returns {boolean} True if user is authorized
     */
    isAuthorized: function isAuthorized(authorizedRoles) {
      if (!angular.isArray(authorizedRoles)) {
        authorizedRoles = [authorizedRoles];
      }
      return this.isAuthenticated() && authorizedRoles.indexOf(userSessionService.userRole) !== -1;
    }
  };
}]);
'use strict';
angular.module('user.services', ['user.services.account-management-service', 'user.services.authentication-interceptor-service', 'user.services.authentication-service', 'user.services.user-session-service']);
'use strict';
// store in the brower's memory some data about the connected user

angular.module('user.services.user-session-service', ['user.model']).factory('userSessionService', ['jwtSessionService', 'User', function (jwtSessionService, User) {
  return {
    /**
     * Returns connected user
     * @returns {object} Connected user
     */
    getUser: function getUser() {
      var user = jwtSessionService.user();
      return user ? new User(user) : null;
    },
    /**
     * Returns connected user id if exists
     * @returns {string} Connected user identifier
     */
    getUserId: function getUserId() {
      var user = this.getUser();
      return user && user.id;
    },
    /**
     * Returns connected user email if exists
     * @returns {string} Connected user email
     */
    getUserEmail: function getUserEmail() {
      var user = this.getUser();
      return user && user.emails && user.emails[0];
    },
    /**
     * Returns jwt id
     * @returns {string} Jwt ID
     */
    getSessionId: function getSessionId() {
      return jwtSessionService.jwt();
    }
  };
}]);